<template>
<div>
  <div :class="{ 'container-telas-mobile' : menuMobileAtivo, 'd-none': isMobile && !menuMobileAtivo }">
    <div
      v-if="!isMobile"
      class="header">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
        <div style="width: 70%;">
          <span
            v-if="!precoOriginalFormatado && precoLabel"
            style="font-size: 14px; line-height: 14px; display: block;">{{ precoLabel }}</span>
          <span
            v-if="precoOriginalFormatado"
            class="preco-original">{{ precoOriginalFormatado }}</span>
          <h2 :style="{'color': corPrimaria}">
            {{ precoFormatado }}
          </h2>
        </div>
        <div style="width: 30%; text-align: right; font-size: 12px; color: #A8A8A8;">
          <span v-if="isDiscount">À vista</span>
          <span v-else-if="maxInstalments > 0 && showInstalment">Em até {{ maxInstalments }}x no cartão</span>
        </div>
      </div>
    </div>
    <div class="body">
      <input-tickets
        v-show="step <= 0"
        v-model="selectedAgeRanges"
        :options="availableAgeRanges"
        :min="quantidadeMinVenda"
        :max="quantidadeMaxVenda"
        :nome-item="$props.nomeItem"
        :only-same-date="onlySameDate"
        :calendar-size="calendarSize"
        :combo-date="comboDate"
        :combo-id="passeioId"
        :initial-available-days="initialAvailableDays"
        :is-mobile="isMobile"
        :moeda="moeda"
        :sub-total="subtotal + totalOpcionais"
        :n-root-steps="nSteps"
        :n-activities="activities.length"
        @on-complience-state-change="complienceChange"
        @next="nextStep"
        @previus="previusStep"
        @dom-height-change="emitHeightUpdate"
        @combo-date-selected="selectComboDate" />

      <activity-step
        v-for="(ac, i) in activities"
        v-show="step == i+1"
        :key="i"
        :value="ac"
        :active="step == i-1"
        :primary-color="corPrimaria"
        :calendar-size="calendarSize"
        :show-remaining-vacancies="showRemainingVacancies"
        :titulo-atividade="tituloAtividade"
        :genero-titulo-atividade="generoTituloAtividade"
        :selected-age-ranges="selectedAgeRanges"
        :n-pessoas="nPessoas"
        :moeda="moeda"
        :only-same-date="onlySameDate"
        :schedule-conflict="getFirstConflictOf(ac.id)"
        :is-mobile="isMobile"
        :sub-total="subtotal + totalOpcionais"
        :n-root-steps="nSteps"
        :n-steps-before="nStepsBeforeActivities + step"
        @input="value => updateActivity(value, i)"
        @next="nextStep"
        @previus="previusStep"
        @dom-height-change="emitHeightUpdate" />

      <finish-screen
        v-show="step > activities.length"
        :prices="selectedPrices"
        :activities="activities"
        :nome-item="nomeItem"
        :disable-finish="!isReady || isSubmitting"
        :has-schedule-conflicts="scheduleConflicts.length > 0"
        :primary-color="corPrimaria"
        :moeda="moeda"
        :is-mobile="isMobile"
        :n-root-steps="nSteps"
        :sub-total="subtotal + totalOpcionais"
        @finish="submit"
        @previus="previusStep" />

        <alerta-pagamento-parcial
        v-if="$props.hasPaymentPartial && !$props.isMobile"
        :preco-parcial-label="$props.precoParcial"
        :porcentagem-parcial="$props.porcentagemParcial"
        :total="(subtotal + totalOpcionais)"
        :moeda="$props.moeda"
        />

      <resumo-compra
        v-if="!isMobile && (descontoPeriodo > 0 || hasOptionals)"
        style="margin-top: 25px;"
        :total="totalSemDesconto"
        :opcionais="totalOpcionais"
        :desconto="descontoPeriodo"
        :moeda="moeda" />
    </div>

    <div
      v-if="!isMobile"
      class="footer">
      <strong
        :key="'subtotal_' + subtotal"
        style="visibility: hidden; display: block;"
        :style="{visibility: isMounted ? 'visible' : 'hidden'}">Subtotal: {{ formatMoney(subtotal + totalOpcionais) }}</strong>
      <span
        v-if="$props.discountByPaymentMethod"
        :key="'totalDesconto_' + totalDesconto"
        style="display: none; color: #2FB97A;"
        :style="{display: (isMounted && totalDesconto < subtotal) ? 'block' : 'none'}">Pagando no {{ discountPaymentMethodsLabel || 'Pix' }}: {{ formatMoney(totalDesconto + totalOpcionais) }}</span>
    </div>
  </div>
  <div class="footer-container-alert-partial-payment" v-if="!menuMobileAtivo">
    <alerta-pagamento-parcial
        v-if="$props.hasPaymentPartial && $props.isMobile"
        :preco-parcial-label="$props.precoParcial"
        :porcentagem-parcial="$props.porcentagemParcial"
        :total="(subtotal + totalOpcionais)"
        :moeda="$props.moeda"
        :is-mobile="true"
        />
  </div>
  
  <div
    v-if="isMobile && !menuMobileAtivo"
    class="footer-container-mobile">
    <div
      v-if="!menuMobileAtivo"
      class="container-resumo">
      <div class="container-precos">
        <small
          v-if="!precoOriginalFormatado && precoLabel"
          style="color: #8D8D8D;">{{ precoLabel }}</small>
        <small
          v-if="precoOriginalFormatado"
          style="color: #8D8D8D; text-decoration: line-through;">De {{ precoOriginalFormatado }}</small>
        <strong
          :style="{'color': corPrimaria, 'font-size': '20px'}">{{ precoOriginalFormatado ? 'Por ' : '' }}{{ precoFormatado }}</strong>
        <small
          v-if="$props.discountByPaymentMethod && precoDescontoFormatado"
          style="color: #3B9A5A;">{{ precoDescontoFormatado }} Pagando no {{ discountPaymentMethodsLabel || 'Pix' }}</small>
      </div>
      <div class="container-btn">
        <button
          :style="{'background-color': corPrimaria}"
          class="btn-reservar"
          @click="menuMobileAtivo = true">
          Reservar
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import InputTickets from './components-combo/InputTickets.vue';
import ResumoCompra from './components/ResumoCompra.vue';
import ActivityStep from './components-combo/ActivityStep.vue';
import FinishScreen from './components-combo/FinishScreen.vue';
import AlertaPagamentoParcial from './components/AlertaPagamentoParcial.vue';


export default {
    components: { InputTickets, ResumoCompra, ActivityStep, FinishScreen, AlertaPagamentoParcial },
    props: {
        passeioId: {
            type: String,
            default: () => '0',
            required: true
        },
        corPrimaria: {
            type: String,
            default: () => '#FF0000',
            required: true
        },
        precoOriginal: {
            type: String,
            default: () => '',
            required: true
        },
        preco: {
            type: String,
            default: () => '',
            required: true
        },
        isDiscount: {
            type: Boolean,
            default: () => false,
            required: true
        },
        maxInstalments: {
            type: Number,
            default: () => 0,
            required: true
        },
        showInstalment: {
            type: Boolean,
            default: () => false,
            required: true
        },
        showRemainingVacancies: {
            type: Boolean,
            default: () => false,
            required: true
        },
        isMobile: {
            type: Boolean,
            default: () => false,
            required: false
        },
        onlySameDate: {
            type: Boolean,
            default: () => false,
            required: true
        },
        calendarSize: {
            type: Number,
            default: () => 2,
            required: true
        },
        quantidadeMinVenda: {
            type: String,
            default: () => '0',
            required: true
        },
        quantidadeMaxVenda: {
            type: String,
            default: () => '9999',
            required: true
        },
        nomeItem: {
            type: String,
            default: () =>'PESSOAS',
            required: false
        },
        moeda: {
            type: String,
            default: () => 'BRL',
            required: true
        },
        precoLabel: {
            type: String,
            default: () => '',
            required: true
        },
        tituloAtividade: {
            type: String,
            default: () => 'Atividade',
            required: false
        },
        generoTituloAtividade: {
            type: String,
            default: () => 'f',
            required: false
        },
        atividades: {
            type: String,
            default: () => '[]',
            required: true
        },
        precos: {
            type: String,
            default: () => '{}',
            required: true
        },
        initialAvailableDays: {
            type: String,
            default: () => '[]',
            required: true
        },
        precoDesconto: {
            type: String,
            default: () => '',
            required: false
        },
        precoParcial: {
            type: String,
            default: () => 0,
            required: false
        },
        porcentagemParcial: {
            type: Number,
            default: () => 0,
            required: false
        },
        hasPaymentPartial: {
            type: Boolean,
            default: () => false,
            required: true
        },
        discountPaymentMethodsLabel: {
            type: String,
            default: '',
        },
        discountByPaymentMethod: {
            type: Boolean,
            default: () => false,
            required: true
        }
    },
    data() {
        const activities = JSON.parse(this.atividades);
        activities.forEach(ac => {
            ac.selectedDay = null;
            ac.selectedAvailability = null;
            ac.selectedOptionals = [];
        });
        return {
            selectedAgeRanges: [],
            quantityOK: false,
            isMounted: false,
            isSubmitting: false,
            activities,
            prices: JSON.parse(this.precos),
            step: 0,
            menuMobileAtivo: false,
        };
    },
    computed: {
        isReady() {
            return this.quantityOK &&
                   this.allActivitiesHasAvailabilitySelected &&
                   this.selectedAgeRanges.length > 0 &&
                   this.scheduleConflicts.length === 0;
        },
        nStepsBeforeActivities() {
            return this.onlySameDate ? 2 : 1;
        },
        nSteps() {
            let n = this.nStepsBeforeActivities;
            n += this.activities.length;
            n++; // Tela de resumo
            return n;
        },
        nPessoas() {
            let n = 0;
            this.selectedAgeRanges.forEach(ticket => n += ticket.quantidade);
            return n;
        },
        totalSemDesconto() { // Soma sem desconto por período nem Pix ou Espécie
            var r = 0.0;
            this.selectedPrices.forEach(price => {
                const precoDe = price.precoDe != null 
                    ? Number(price.precoDe)
                    : Number(price.preco);
                r += precoDe * price.quantidade;
            });
            return r;
        },
        subtotal() { // Soma dos valores considerando desconto por período, mas sem desconto por pagar à vista
            var r = 0.0;
            this.selectedPrices.forEach(price => {
                r += Number(price.preco) * price.quantidade;
            });
            return r;
        },
        descontoPeriodo() { // Total economizado por ter escolhido um período promocional, sem considerar desconto por pagar à vista
            return this.totalSemDesconto - this.subtotal;
        },
        totalDesconto() { // Total já considerando desconto por período e também por pagar à vista
            var r = 0.0;
            this.selectedPrices.forEach(price => {
                const preco = price.precoDesconto != null 
                    ? Number(price.precoDesconto)
                    : Number(price.preco);
                r += preco * price.quantidade;
            });
            return r;
        },
        // Nota: Nenhum dos valores computados acima considera a existencia de opcionais
        totalOpcionais() { // Soma do valor dos opcionais
            var r = 0.0;
            this.activities.forEach(ac => {
                ac.selectedOptionals.forEach(op => {
                    const preco = Number(op.preco);
                    r += preco * op.quantidade;
                });
            });
            return r;
        },
        hasOptionals() {
            for (let i = 0; i < this.activities.length; i++) {
                if(this.activities[i].selectedOptionals.length > 0) {
                    return true;
                }
            }
            return false;
        },
        selectedPrices() {
            if(this.comboWeekDay === null) {
                return [];
            }
            const r = [];
            this.selectedAgeRanges.forEach(faixa => {
                this.pricesOfComboOnDate.forEach(price => {
                    if(price.faixa_etaria_id != faixa.id) {
                        return;
                    }
                    const clone = JSON.parse(JSON.stringify(price));
                    clone.quantidade = faixa.quantidade;
                    r.push(clone);
                });
            });
            return r;
        },
        availableAgeRanges() {
            const r = [];
            const alreadyAdded = [];
            const prices = Object.values(this.prices);
            prices.forEach(price => {
                if(alreadyAdded.includes(price.faixa_etaria_id)) {
                    return;
                }
                alreadyAdded.push(price.faixa_etaria_id);
                r.push({
                    id: price.faixa_etaria_id,
                    nome: price.nome,
                    descricao: price.descricao,
                    dependente: price.dependente,
                    ordem: price.ordem,
                });
            });

            r.sort((a, b) => Number(a.ordem)-Number(b.ordem));

            return r;
        },
        comboDate() {
            if(this.activities[0].selectedDay === null) {
                return null;
            }
            return new Date(this.activities[0].selectedDay.getTime());
        },
        comboWeekDay() {
            if(this.comboDate === null) {
                return null;
            }
            const numericWeekDay = this.comboDate.getDay();
            const weekDays = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB'];
            return weekDays[numericWeekDay];
        },
        pricesOfComboOnDate() {
            if(this.comboWeekDay === null) {
                return [];
            }
            const r = [];
            Object.values(this.prices).forEach(price => {
                if(!price.dias_semana.includes(this.comboWeekDay)) {
                    return;
                }
                r.push(this.getPriceOfComboDate(price));
            });
            return r;
        },
        allActivitiesHasAvailabilitySelected() {
            for (let i = 0; i < this.activities.length; i++) {
                if(this.activities[i].selectedAvailability === null) {
                    return false;
                }
            }
            return true;
        },
        precoFormatado() {
            const preco = Number(this.$props.preco);
            if(isNaN(preco)) {
                return this.formatMoney(0);
            }
            return this.formatMoney(preco);
        },
        precoDescontoFormatado() {
            const preco = Number(this.$props.precoDesconto);
            if(isNaN(preco) || preco <= 0) {
                return '';
            }
            return this.formatMoney(preco);
        },
        precoOriginalFormatado() {
            const preco = Number(this.$props.precoOriginal);
            if(isNaN(preco) || preco <= 0) {
                return '';
            }
            return this.formatMoney(preco);
        },
        scheduleConflicts() {
            const r = [];
            for(let i = 0; i < this.activities.length - 1; i++) {
                const ac1 = this.activities[i];
                for (let j = i+1; j < this.activities.length; j++) {
                    const ac2 = this.activities[j];
                    const conflict = this.calculateConflict(ac1, ac2);
                    if(conflict !== null) {
                        r.push(conflict);
                    }
                }
            }
            return r;
        }
    },
    watch: {
        selectedAgeRange() {
            this.$nextTick(this.emitHeightUpdate);
        },
        descontoPeriodo() {
            this.$nextTick(this.emitHeightUpdate);
        },
        isMounted() {
            setTimeout(this.emitHeightUpdate, 100);
        },
        totalOpcionais() {
            this.$nextTick(this.emitHeightUpdate);
        },
        step() {
            this.$nextTick(this.emitHeightUpdate);
        },
        hasOptionals() {
            this.$nextTick(this.emitHeightUpdate);
        },
        menuMobileAtivo() {
            const body = document.getElementsByTagName('body')[0];
            if(this.menuMobileAtivo) {
                body.style.overflow = 'hidden';
            } else {
                body.style.overflow = 'auto';
            }
        }
    },
    mounted() {
        this.emitHeightUpdate();
        this.isMounted = true;
    },
    methods: {
        resetState() {
            this.selectedAgeRanges = [];
            this.selectedOptionals = [];
            this.quantityOK = false;
            this.isSubmitting = false;
        },
        nextStep() {
            if(this.step > this.activities.length) {
                return;
            }
            this.step++;
        },
        previusStep() {
            if(this.step <= 0) {
                this.menuMobileAtivo = false;
                return;
            }
            this.step--;
        },
        updateActivity(value, i) {
            const copy = [];
            this.activities.forEach((ac, j) => {
                copy[j] = JSON.parse(JSON.stringify(ac));
                copy[j].selectedDay = ac.selectedDay;
            });
            copy[i] = JSON.parse(JSON.stringify(value));
            copy[i].selectedDay = value.selectedDay;
            this.activities = copy;
        },
        emitHeightUpdate() {
            if(!window.parent || this.isMobile) {
                return;
            }
            const calendar = document.getElementById('calendarioVendaApp');
            const event = new CustomEvent('paytCalendarHeightUpdate', { detail: { height: calendar.offsetHeight } });
            window.parent.document.dispatchEvent(event);
        },
        complienceChange(ok) {
            this.quantityOK = ok;
            this.$nextTick(this.emitHeightUpdate);
        },
        calendarOpened() {
            this.$nextTick(this.emitHeightUpdate);
        },
        formatMoney(price) {
            let locale = 'pt-Br';

            if (this.$props.moeda === 'USD') {
                locale = 'en-US';
            }

            if(price <= 0 || price === null) {
                return Number(0.00).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
            }
            return Number(price).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
        },
        dataFormatada(data) {
            if(!data) {
                data = new Date();
            }
            const mes = data.toLocaleDateString('pt-BR', { month: '2-digit' });
            const dia = data.toLocaleDateString('pt-BR', { day: '2-digit' });
            const ano = data.toLocaleDateString('pt-BR', { year: 'numeric' });
            return dia + '/' + mes + '/' + ano;
        },
        getFirstConflictOf(acId) {
            for(let i = 0; i < this.scheduleConflicts.length; i++) {
                const conflict = this.scheduleConflicts[i];
                if(conflict.first.id === acId || conflict.second.id === acId) {
                    return conflict;
                }
            }
            return null;
        },
        calculateConflict(ac1, ac2) {
            // Se não tem data selecionada, não tem conflito
            if(ac1.selectedAvailability == null || ac2.selectedAvailability == null) {
                return null;
            }
            // Se qualquer uma das atividades é com horário livre, considere sem conflito
            if(ac1.tipo_passeio == 'livre' || ac2.tipo_passeio == 'livre') {
                return null;
            }
            // A atividade 1 deve ser antes da atividade 2 para calcular corretamente o conflito
            if(this.getStartMomentOfActivity(ac1).isAfter(this.getStartMomentOfActivity(ac2))) {
                const tmp = ac1;
                ac1 = ac2;
                ac2 = tmp;
            }
            // Se a atividade 1 termina antes da atividade 2 começar, não tem conflito
            const startAc2 = this.getStartMomentOfActivity(ac2);
            const endAc1 = this.getEndMomentOfActivity(ac1);
            if(endAc1.isSameOrBefore(startAc2)) {
                return null;
            }
            const r = {
                first: JSON.parse(JSON.stringify(ac1)),
                second: JSON.parse(JSON.stringify(ac2)),
            };
            r.first.endMoment = endAc1;
            r.second.startMoment = startAc2;
            return r;
        },
        emitEventVenda(success = false, errorMsg = null, urlRedirect = null, data = null) {
            if(!window.parent) {
                return;
            }
            const event = new CustomEvent('paytVendaConcluida', {
                detail: {
                    success: success,
                    redirectTo: urlRedirect,
                    data: data,
                    error: errorMsg,
                } 
            });
            window.parent.document.dispatchEvent(event);
        },
        getStartMomentOfActivity(ac) {
            if(!ac) {
                return null;
            }
            if(ac.selectedDay === null || ac.selectedAvailability === null) {
                return null;
            }
            const startTime = ac.selectedAvailability.hora_de ? ac.selectedAvailability.hora_de : '00:00:00';
            const [startH, startM, startS] = startTime.split(':');
            const r = moment(ac.selectedDay);
            r.set({
                hour: Number(startH),
                minute: Number(startM),
                second: Number(startS),
                millisecond: 0
            });
            return r;
        },
        getEndMomentOfActivity(ac) {
            const r = this.getStartMomentOfActivity(ac);
            if(r === null) {
                return null;
            }
            r.add(ac.tempo_execucao, 'minutes');
            return r;
        },
        getPriceOfComboDate(priceObj) {
            const defaultPrice = {
                'id': priceObj.id,
                'faixa_etaria_id': priceObj.faixa_etaria_id,
                'faixa_nome': priceObj.nome,
                'faixa_descricao': priceObj.descricao,
                'precoDe': null,
                'preco': parseFloat(priceObj.preco),
                'precoDesconto': priceObj.preco_desconto !== null ? parseFloat(priceObj.preco_desconto) : null
            };
            if(!this.comboDate) {
                return defaultPrice;
            }

            if(
                typeof priceObj.precos_sazonais !== 'object' ||
                Array.isArray(priceObj.precos_sazonais) ||
                priceObj.precos_sazonais === null
            ) {
                return defaultPrice;
            }

            const currentDate = moment(this.comboDate);
            const precosSazonaisIds = Object.keys(priceObj.precos_sazonais);
            for (let i = 0; i < precosSazonaisIds.length; i++) {
                if (
                    currentDate >= moment(priceObj.precos_sazonais[precosSazonaisIds[i]].data_inicio, 'YYYY-MM-DD') &&
                    currentDate <= moment(priceObj.precos_sazonais[precosSazonaisIds[i]].data_fim, 'YYYY-MM-DD')
                ) {
                    const price = priceObj.precos_sazonais[precosSazonaisIds[i]];
                    return {
                        'id': price.id,
                        'precoDe': (price.preco_promocao_de !== null && price.promocao == 1) ? parseFloat(price.preco_promocao_de) : null,
                        'preco': parseFloat(price.preco),
                        'precoDesconto': price.preco_desconto !== null ? parseFloat(price.preco_desconto) : null,
                        'faixa_etaria_id': priceObj.faixa_etaria_id,
                        'faixa_nome': priceObj.nome,
                        'faixa_descricao': priceObj.descricao,
                    };
                }
            }

            return defaultPrice;
        },
        selectComboDate(newDate) {
            const activities = JSON.parse(JSON.stringify(this.activities));
            activities.forEach(ac => {
                ac.selectedDay = newDate;
                ac.selectedAvailability = null;
            });
            this.activities = activities;
        },
        async submit() {
            if(!this.isReady || this.isSubmitting) {
                return false;
            }
            this.isSubmitting = true;

            const form = new FormData();
            form.append('type', 'combo');
            form.append('productId', this.passeioId);

            this.selectedAgeRanges.forEach(preco => {
                form.append('quantity[' + preco.id + ']', preco.quantidade);
            });
            this.activities.forEach((ac, i) => {
                form.append('activities[' + i + '][id]', ac.id);
                form.append('activities[' + i + '][date]', this.dataFormatada(ac.selectedDay));
                form.append('activities[' + i + '][time]', ac.selectedAvailability.id);
                ac.selectedOptionals.forEach(opt => {
                    form.append('activities[' + i + '][preSelectedOptionals][' + opt.id + ']', opt.quantidade);
                });
            });

            try {
                const r = await axios.post('/adicionar-ao-carrinho', form);
                if(!r || !r.data || !r.data.redirectUrl) {
                    this.emitEventVenda(false, 'O servidor não respondeu corretamente');
                    return false;
                }
                this.emitEventVenda(true, null, r.data.redirectUrl, {
                    idCombo: this.passeioId,
                    data: JSON.parse(JSON.stringify(this.activities)),
                    tickets: JSON.parse(JSON.stringify(this.selectedAgeRanges))
                });
            } catch {
                this.emitEventVenda(false, 'Falha na conexão com o servidor');
                return false;
            } finally {
                this.isSubmitting = false;
            }

            this.resetState();
            return true;
        }
    }
};
</script>
<style scoped>
.footer-container-mobile {
    width: 100%;
    height: 80px;
    background-color: white;
    z-index: 200;
    position: fixed;
    bottom: 0px;
    left: 0px;
}

.footer-container-alert-partial-payment {
    width: 100%;
    background-color: white;
    z-index: 200;
    position: fixed;
    bottom: 80px;
    left: 0px;
}

.container-resumo {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    width: 100%;
}

.container-precos {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 50%;
    height: 90%;
    line-height: 18px;
}

.container-btn {
    width: 40%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.btn-reservar {
    padding: 15px;
    border-radius: 6px;
    border: none;
    width: 90%;
    color: white;
}

.container-telas-mobile {
    width: 100%;
    height: 100dvh;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    background-color: white;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
